import Loader from '../../../../Common/Loader'
import useProposalAssetsUpload from '../hooks/useProposalAssetsUpload'
import styles from './ExternalAssetsUploadStep.css'
import ExternalErrorStep from './ExternalErrorStep'

const ExternalAssetsUploadStep = () => {
  const { uploadProgress, downloaded } = useProposalAssetsUpload()
  const { uploaded, total } = uploadProgress

  return (
    <ExternalErrorStep>
      <div className={styles.container}>
        <div className={styles.loadingContent}>
          {total > 0 && (
            <span className={styles.progress}>
              {`${uploaded} / ${total}`}
            </span>
          )}
          <Loader
            message={downloaded ? '上傳檔案中' : '下載檔案中'}
            spinning
          />
        </div>
      </div>
    </ExternalErrorStep>
  )
}

export default ExternalAssetsUploadStep
